var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarHeaderShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "249px",
    height: "30px",
    viewBox: "0 0 249 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CalendarHeaderShape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CalendarHeaderShape",
    fill: "#549608",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.686087,29.8888344 C58.5796333,29.5537119 56.6276461,25.1941918 56.6276461,20.9136963 C56.6276461,16.6339325 56.6276461,13.4788048 55.5031317,9.70026141 C54.7539432,7.18098857 52.1961668,5.70659566 47.8312659,5.27708269 L0.0365853659,5.12196046 L0.0365853659,0 L47.8312659,0.0570732737 L124.518293,0.0354280485 L157.205319,0.0570732737 L249,0 L249,5.12196046 L157.205319,5.27708269 C152.840419,5.70659566 150.282642,7.18098857 149.533454,9.70026141 C148.408939,13.4788048 148.408939,16.6339325 148.408939,20.9136963 C148.408939,25.1941918 146.456952,29.5537119 138.350498,29.8888344 C134.008298,30.06755 127.917538,29.7905491 124.518309,29.7780574 C107.980717,29.8388307 71.0282873,30.06755 66.686087,29.8888344 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarHeaderShape);
export default __webpack_public_path__ + "static/media/CalendarHeaderShape.a6763eefeaa2e59e8a4435d39b395092.svg";
export { ForwardRef as ReactComponent };